// extracted by mini-css-extract-plugin
module.exports = {"list":"FieldComparison_list__2peYD","section":"FieldComparison_section__28j_5","expressionsActionsBtns":"FieldComparison_expressionsActionsBtns__Pi7RK"};